module.exports = __webpack_public_path__ + "static/media/carousal_4.b776c97c.png";